import Button from "@/common/components/Button";
import { useAdvanceMaintenanceDirectiveExecutionEntry } from "@/features/maintenance/features/workflows/features/executionEntries/hooks/useAdvanceMaintenanceDirectiveExecutionEntry";
import { useForwardingTabContext } from "@/features/maintenance/features/workflows/hooks/forwardings/useForwardingTabContext";
import { MaintenanceForwardingsDirectiveEntryKlass } from "@/features/maintenance/features/workflows/types/forwardings/maintenanceForwardingsDirectiveEntryKlasses.type";
import { useQueryClient } from "@tanstack/react-query";
import { useMemo } from "react";

const DirectiveEntryExecutionEntryInProgress = () => {
  const { forwarding, forwardingUpdatedAt } = useForwardingTabContext<
    MaintenanceForwardingsDirectiveEntryKlass.ExecutionEntry
  >();

  const queryClient = useQueryClient();

  const {
    mutate: advanceExecutionEntry,
    isPending: advanceExecutionEntryIsPending,
  } = useAdvanceMaintenanceDirectiveExecutionEntry({
    directiveEntryId: forwarding.directive_entry.id,
    options: {
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: ['maintenanceForwarding', forwarding.id] });
      },
    },
  });

  const isEveryObjectiveCompleted = useMemo(() => {
    return !forwarding?.directive_entry?.objectives?.some((objective) => objective.status !== 'complete');
  }, [forwardingUpdatedAt]);

  return (
    <Button
      onClick={() => advanceExecutionEntry()}
      isLoading={advanceExecutionEntryIsPending}
      operationKlassToCheckPermission="Establishment::Maintenance::Directive::ExecutionEntries::Advance"
      disabled={!isEveryObjectiveCompleted}
    >
      Finalizar Manutenção
    </Button>
  );
}

export default DirectiveEntryExecutionEntryInProgress;
